import { useEffect, useState } from 'react';

export function useForceUpdate(deps: any[]) {
  const [_, forceUpdate] = useState(0);

  useEffect(() => {
    forceUpdate(prev => prev + 1);
  }, [...deps]);
}
